import React from "react";
import {Redirect, Route} from "react-router-dom";
import {canAccess} from "../../utils/auth/permissions";

const AppRoutes = ({
  component: Component,
  path,
  isPrivate,
  module,
  ...rest
}) => {
  const hasToken = !!localStorage.getItem("access_token");
  const hasAccess = canAccess(module, isPrivate);

  return (
    <Route
      path={path}
      render={(props) => {
        if (hasAccess) {
          return <Component {...props} />;
        }

        // If private route and no token, redirect to login
        if (isPrivate && !hasToken) {
          return <Redirect to={{pathname: "/login"}} />;
        }

        // If has token but no access, redirect to no-access
        return <Redirect to={{pathname: "/no-access"}} />;
      }}
      {...rest}
    />
  );
};

export default AppRoutes;
